import * as React from 'react';
import MyTypes from 'MyTypes';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { Card, Form, Button, OverlayTrigger, Row, Col, Tooltip } from 'react-bootstrap';
import SingleActionButton from '../common/SingleActionButton';
import addIcon from '../../assets/images/Blue/add.svg';
import _ from 'lodash'; 
import * as router from '../../services/router-service'; 
import * as models from '../../models/'
import { contactsActions } from 'store/contacts';
import { ContactStatus, LoginStatus } from '../../models/contacts/contactsRequest';
import ContactsTable from './ContactList';
import Pager from 'components/common/Pager';
import '../../assets/styles/Administration.css'; 
import infoIcon from '../../assets/images/Blue/info-circle.svg'; 

interface Props extends PropsFromRedux {
}

interface State {
    contactsListRequest: models.ContactsRequest, 
    showDetailsModal: boolean, 
}

class ContactsSearch extends React.Component<Props, State> {
    public state = {
        contactsListRequest: {...this.props.contactListRequest}, 
        showDetailsModal: false,        
    };

    public componentDidMount(): void {
        this.fetchFormData(this.state.contactsListRequest);
    }

    private applyFilters = (e:any) => {
        e.preventDefault(); 
        const { contactsListRequest } = this.state;

        let request: models.ContactsRequest = {
            ...contactsListRequest,             
        };

        switch (e.target.name) {
            case 'company':
                request.companyName = e.target.value; 
                break;
            case 'loginStatus':
                request.loginStatus = e.target.value as LoginStatus; 
                break;
            case 'status':
                request.status = e.target.value as models.ContactStatus; 
                break;
            default:
                break;
        }
        
        this.setState({contactsListRequest: request}); 
        this.fetchFormData(request);
    }

    private handleSearchSubmit = async (e: any) => {
        const { contactsListRequest } = this.state; 
        this.fetchFormData(contactsListRequest); 
        e.preventDefault(); 
    };

    public fetchFormData = (request: models.ContactsRequest) => {   
        this.props.requestContactList(request);
    }

    public addNew = () => {        
        router.goto(router.url.contactDetail.replace(":contactId", '0')); 
    }

    public resetFilters = () => {
        this.setState({
            contactsListRequest: {...models.defaultContactsRequest}, 
        }); 
        this.fetchFormData(models.defaultContactsRequest);
    }

    public pagerCallback = (paging: models.Paging) => { 
        const sizeChanged = paging.pageSize !== this.state.contactsListRequest.pageSize;
        const request: models.ContactsRequest = {
            ...this.state.contactsListRequest,
            ...paging,  
            pageNo: sizeChanged ? 1 : paging.pageNo
        };
        this.setState({contactsListRequest: request}); 
        this.props.requestContactList(request); 
    };

    render() {
        const { contactsListRequest } = this.state;
        const { companyList, contactListResponse } = this.props;
        const showPagination = contactListResponse?.totalCount > contactListResponse?.pageSize! ? true : false; 

        return (
            <>
                <Card className="claim-card">
                    <Card.Title>Contact Search
                        <SingleActionButton
                            action="Add"
                            title="Contact"
                            img={addIcon}
                            onClick={this.addNew}
                        />
                    </Card.Title>
                    <Form onSubmit={this.handleSearchSubmit}>
                        <Card.Body style={{display: "flex", flexDirection: "column", gap: "15px"}}>
                            <Row xs={4} md={4}>                                
                                <Col>
                                    <Form.Group>
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control 
                                            name="firstName" 
                                            placeholder='First Name...' 
                                            value={contactsListRequest.firstName || ""} 
                                            onChange={(e) => this.setState({contactsListRequest: {...contactsListRequest, firstName: e.target.value}})} 
                                            />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control 
                                            name="lastName" 
                                            placeholder='Last Name...' 
                                            value={contactsListRequest.lastName || ""} 
                                            onChange={(e) => this.setState({contactsListRequest: {...contactsListRequest, lastName: e.target.value}})} 
                                            />
                                    </Form.Group>   
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Email
                                            <OverlayTrigger
                                                key="overlayTrigger"
                                                placement="top"
                                                overlay={
                                                    <Tooltip className="my-tooltip" id="toolTip">Searches both Email and Compass Email fields</Tooltip>
                                                }
                                            >
                                                <img className="info-icon" src={infoIcon}/>
                                            </OverlayTrigger>    
                                        </Form.Label>
                                        <Form.Control 
                                            name="email" 
                                            placeholder='Email...' 
                                            value={contactsListRequest.email || ""} 
                                            onChange={(e) => this.setState({contactsListRequest: {...contactsListRequest, email: e.target.value}})} 
                                            />
                                    </Form.Group>   
                                </Col>    
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Company</Form.Label>
                                        <Form.Select 
                                            name="company" 
                                            value={contactsListRequest.companyName || ""} 
                                            onChange={(e) => this.applyFilters(e)}  
                                        >
                                            <option key={-1} value=""></option>
                                            {companyList && companyList.map((c: models.DropDownListItem, i: number) => (                                             
                                                <option key={i} value={c.name} >{c.name}</option>
                                            ))}
                                        </Form.Select>                                    
                                    </Form.Group>    
                                </Col>                                                                        
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Status</Form.Label>
                                        <Form.Select 
                                            name="status"
                                            value={contactsListRequest.status}
                                            onChange={(e) => this.applyFilters(e)}  
                                        >
                                            {Object.values(ContactStatus).map(statusValue => (
                                                <option key={statusValue} value={statusValue}>
                                                    {statusValue}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Login Status</Form.Label>
                                        <Form.Select 
                                            name="loginStatus"
                                            value={contactsListRequest.loginStatus}
                                            onChange={(e) => this.applyFilters(e)}  
                                        >
                                            {Object.values(LoginStatus).map(statusValue => (
                                                <option key={statusValue} value={statusValue}>
                                                    {statusValue}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>  
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Xn Address
                                            <OverlayTrigger
                                                key="overlayTrigger"
                                                placement="top"
                                                overlay={
                                                    <Tooltip className="my-tooltip" id="toolTip">Searches both XnAddress and XnAddrsss 2 fields</Tooltip>
                                                }
                                            >
                                                <img className="info-icon" src={infoIcon}/>
                                            </OverlayTrigger>                        
                                        </Form.Label>
                                        <Form.Control 
                                            name="xnAddress" 
                                            placeholder='Xn Address...' 
                                            value={contactsListRequest.xnAddress || ""} 
                                            onChange={(e) => this.setState({contactsListRequest: {...contactsListRequest, xnAddress: e.target.value}})} 
                                            />
                                    </Form.Group>   
                                </Col>                                  
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Connect ID</Form.Label>
                                        <Form.Control 
                                            name="connectId" 
                                            placeholder='Connect ID...' 
                                            value={contactsListRequest.connectId || ""} 
                                            onChange={(e) => this.setState({contactsListRequest: {...contactsListRequest, connectId: parseInt(e.target.value)}})} 
                                            />
                                    </Form.Group>   
                                </Col> 
                            </Row>
                            <Row>
                                <Col>
                                    <Button className="claim-search-btn" type='submit'>Search</Button>
                                    <Button className="claim-search-btn" onClick={this.resetFilters}>Reset Filters</Button>
                                </Col>
                            </Row>                           
                        </Card.Body>
                    </Form>
                </Card>
                <ContactsTable/>
                {showPagination &&
                <div>
                    <Pager
                        className = {"admin-pager"}
                        retrieveDataCallback = {this.pagerCallback}
                        pageSize = {contactListResponse?.pageSize || 20}
                        currentPage = {contactListResponse?.pageNo || 1}
                        totalCount = {contactListResponse?.totalCount || 0}
                        pagesInRange = {3}
                    />
                </div>
            }
            </>
        );
    }
}
const mapStateToProps = (state: MyTypes.RootState) => ({
    contactListRequest: state.contacts.search.contactListRequest,
    contactListResponse: state.contacts.search.contactListResponse,
    companyList: state.contacts.search.contactListResponse.companies,
}); 

const mapDispatchToProps = (dispatch: Dispatch) => 
    bindActionCreators(
        {       
            requestContactList: contactsActions.requestContactList, 
        },
        dispatch
    );

const connector = connect(mapStateToProps, mapDispatchToProps); 
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(ContactsSearch); 